export const Z_MODAL = {
  ENQUIRY_DETAILS: "z-[99999]",
  CONTACT: "z-[99999]",
  LEAD_QUALITY_SCORE: "z-[99999]",
};